import { render } from "./TheMobileTabBar.vue?vue&type=template&id=3e845632&scoped=true"
import script from "./TheMobileTabBar.vue?vue&type=script&lang=js"
export * from "./TheMobileTabBar.vue?vue&type=script&lang=js"

import "./TheMobileTabBar.vue?vue&type=style&index=0&id=3e845632&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e845632"]])

export default __exports__